// services/supabase.ts — Platik-IA
// Cliente único de Supabase. Importar solo desde módulos via su adapter.

import { createClient } from '@supabase/supabase-js';
import { env } from '../core/env';
import type { Database } from './supabase.types';

export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession:    true,
      autoRefreshToken:  true,
      detectSessionInUrl: true,
      // PKCE: el redirect trae un `?code=` de un solo uso (no tokens en la URL)
      flowType:          'pkce',
    },
  }
);
